import { render } from "./CategorySeven.vue?vue&type=template&id=73976c3b"
import script from "./CategorySeven.vue?vue&type=script&lang=js"
export * from "./CategorySeven.vue?vue&type=script&lang=js"

import "./CategorySeven.vue?vue&type=style&index=0&id=73976c3b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__